(function ($) {
    const { animate, stagger, onScroll } = anime;
    const debug = false;
    $(document).ready(function () {
        fadeBottom();
        fadeTop();
        fadeRight();
        fadeLeft();
        staggerGroup();
    });

    function fadeBottom() {
        $(".fadeBottom").each(function () {
            animate(this, {
                opacity: [0, 1],
                y: ["5rem", 0],
                ease: "linear",
                duration: 300,
                autoplay: onScroll({
                    container: "body",
                    enter: "bottom-=50 top",
                    leave: "top+=60 bottom",
                    debug: debug,
                }),
            });
        });
    }

    function fadeTop() {
        $(".fadeTop").each(function () {
            animate(this, {
                opacity: [0, 1],
                y: ["-5rem", 0],
                ease: "linear",
                duration: 300,
                autoplay: onScroll({
                    container: "body",
                    enter: "bottom-=50 top",
                    leave: "top+=60 bottom",
                    debug: debug,
                }),
            });
        });
    }

    function fadeRight() {
        $(".fadeRight").each(function () {
            animate(this, {
                opacity: [0, 1],
                x: ["5rem", 0],
                ease: "linear",
                duration: 300,
                autoplay: onScroll({
                    container: "body",
                    enter: "bottom-=50 top",
                    leave: "top+=60 bottom",
                    debug: debug,
                }),
            });
        });
    }

    function fadeLeft() {
        $(".fadeLeft").each(function () {
            animate(this, {
                opacity: [0, 1],
                x: ["-5rem", 0],
                ease: "linear",
                duration: 300,
                autoplay: onScroll({
                    container: "body",
                    enter: "bottom-=50 top",
                    leave: "top+=60 bottom",
                    debug: debug,
                }),
            });
        });
    }

    function staggerGroup() {
        if ($(".staggerGroup").length > 0) {
            $(".staggerGroup").each(function (index) {
                let elem_class = "stagger-" + index;
                $(this).children().addClass(elem_class);
                animate(".stagger-" + index, {
                    opacity: [0, 1],
                    y: ["-5rem", 0],
                    delay: stagger(100, { start: 100 }),
                    duration: 300,
                    autoplay: onScroll({
                        container: "body",
                        enter: "bottom-=50 top",
                        leave: "top+=60 bottom",
                        debug: debug,
                    }),
                });
            });
        }

        if ($(".staggerGroup-2").length > 0) {
            $(".staggerGroup-2").each(function (index) {
                let elem_class_2 = "stagger-2-" + index;
                $(this).children().addClass(elem_class_2);
                animate("." + elem_class_2, {
                    opacity: [0, 1],
                    x: ["-5rem", 0],
                    delay: stagger(100, { start: 100 }),
                    duration: 300,
                    autoplay: onScroll({
                        container: "body",
                        enter: "bottom-=50 top",
                        leave: "top+=60 bottom",
                        debug: debug,
                    }),
                });
            });
        }
    }

    (function (document, history, location) {
        var HISTORY_SUPPORT = !!(history && history.pushState);

        var anchorScrolls = {
            ANCHOR_REGEX: /^#[^ ]+$/,
            OFFSET_HEIGHT_PX: 50,

            /**
             * Establish events, and fix initial scroll position if a hash is provided.
             */
            init: function () {
                this.scrollToCurrent();
                $(window).on("hashchange", $.proxy(this, "scrollToCurrent"));
                $("body").on("click", "a", $.proxy(this, "delegateAnchors"));
            },

            /**
             * Return the offset amount to deduct from the normal scroll position.
             * Modify as appropriate to allow for dynamic calculations
             */
            getFixedOffset: function () {
                // return this.OFFSET_HEIGHT_PX;

                let height = $("header .image-container img").height();

                if ($(window).width() < 992) {
                    height = 140;
                }

                return height;
            },

            /**
             * If the provided href is an anchor which resolves to an element on the
             * page, scroll to it.
             * @param  {String} href
             * @return {Boolean} - Was the href an anchor.
             */
            scrollIfAnchor: function (href, pushToHistory) {
                var match, anchorOffset;

                if (!this.ANCHOR_REGEX.test(href)) {
                    return false;
                }

                match = document.getElementById(href.slice(1));

                if (match) {
                    anchorOffset =
                        $(match).offset().top - this.getFixedOffset();
                    $("html, body").animate({ scrollTop: anchorOffset });

                    // Add the state to history as-per normal anchor links
                    if (HISTORY_SUPPORT && pushToHistory) {
                        history.pushState(
                            {},
                            document.title,
                            location.pathname + href
                        );
                    }
                }

                return !!match;
            },

            /**
             * Attempt to scroll to the current location's hash.
             */
            scrollToCurrent: function (e) {
                if (this.scrollIfAnchor(window.location.hash) && e) {
                    e.preventDefault();
                }
            },

            /**
             * If the click event's target was an anchor, fix the scroll position.
             */
            delegateAnchors: function (e) {
                var elem = e.target;

                if (this.scrollIfAnchor(elem.getAttribute("href"), true)) {
                    e.preventDefault();
                }
            },
        };

        $(document).ready($.proxy(anchorScrolls, "init"));
    })(window.document, window.history, window.location);
})(jQuery);
